import { createBrowserHistory } from 'history';
import { isNullOrUndefined } from 'is-what';

// Build history for React Router
export const history = createBrowserHistory({
  basename: !isNullOrUndefined(process.env.REACT_APP_PUBLIC_PATH)
    ? process.env.REACT_APP_PUBLIC_PATH
    : process.env.PUBLIC_URL,
});
